import useSubscriptionInfo from 'app/hooks/subscriptions/useSubscriptionInfo';
import React from 'react';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import { Dialog } from '@progress/kendo-react-dialogs';
import { BackActionDialogContentLayout } from 'app/components/layouts';
import { BasicPlanView, InitialPlanView, PremiumPlanView } from './components';
import './ManageYourPlanDialog.less';
import { useTranslation } from 'react-i18next';
import useClickOutside from 'app/hooks/useClickOutside';
import clsx from 'clsx';

interface Props {
  equipment: IEquipmentEntry;
  onBack: () => void;
}

export default function ManageYourPlanDialog({ equipment, onBack }: Props) {
  const { t } = useTranslation();
  const subscriptionInfo = useSubscriptionInfo(equipment.subscriptions);

  useClickOutside(onBack);

  function renderContent() {
    if (subscriptionInfo.isInitial) {
      return (
        <InitialPlanView
          equipment={equipment}
          subscriptionInfo={subscriptionInfo}
        />
      );
    }

    if (subscriptionInfo.hasPremium) {
      return (
        <PremiumPlanView
          equipment={equipment}
          subscriptionInfo={subscriptionInfo}
        />
      );
    }

    return <BasicPlanView equipment={equipment} />;
  }

  return (
    <Dialog
      className={clsx('modal-container', {
        // basic modal is wider than the premium one
        'manage-your-plan-dialog_restricted-width': subscriptionInfo.hasPremium,
      })}
    >
      <BackActionDialogContentLayout
        withShadow={false}
        className="manage-your-plan-dialog"
        contentProps={{ className: 'manage-your-plan-dialog__content' }}
        onBack={onBack}
      >
        <h2 className="manage-your-plan-dialog__title">
          {t('subscriptions.manage_your_plan.title')}
        </h2>

        {renderContent()}
      </BackActionDialogContentLayout>
    </Dialog>
  );
}
